<section>
	<h3>{{'Treatment plan' | translate}}</h3>
	<form [formGroup]="questionnaireForm">
		<!-- Prealigner UK & Distraktionsschiene OK -->
		<section>
			<div class="required-header"
				 [ngClass]="{invalid: !preAlignerDistractionSplint.valid}">
				<h3>{{ getHeadline(OrcadentQuestionnaireSection.PRE_ALIGNER_DISTRACTION_SPLINT) | translate}}</h3>
				<i (click)="onHelpClicked(OrcadentQuestionnaireSection.PRE_ALIGNER_DISTRACTION_SPLINT)" class="fa-light fa-circle-question"></i>
				@if (!preAlignerDistractionSplint.valid) {
					<p>({{"required" | translate}})</p>
				}
			</div>
			<div>
				<mat-radio-group formControlName="preAlignerDistractionSplint">
					<mat-radio-button [value]="true">{{ "Yes" | translate}}</mat-radio-button>
					<mat-radio-button [value]="false">{{ "No" | translate}}</mat-radio-button>
				</mat-radio-group>
			</div>
		</section>

		<!-- Bisshöhenanweisung (artikulationsbezogen)-->
		<section>
			<div class="required-header"
				 [ngClass]="{invalid: !occlusalHeightInstruction.valid}">
				<h3>{{ getHeadline(OrcadentQuestionnaireSection.OCCLUSAL_HEIGHT_INSTRUCTION) | translate}}</h3>
				@if (!occlusalHeightInstruction.valid) {
					<p>({{"required" | translate}})</p>
				}
			</div>
			<occlusal-height-form
				[parentForm]="questionnaireForm">
			</occlusal-height-form>
		</section>

		<!-- folgende Zähne nicht bewegen -->
		<section>
			<h3>{{ getHeadline(OrcadentQuestionnaireSection.NON_MOVING_TEETH) | translate}}</h3>
			<textarea id="nonMovingTeeth" formControlName="nonMovingTeeth"
			></textarea>
		</section>

		<!-- Mittellinie -->
		<section>
			<div class="required-header"
				 [ngClass]="{invalid: !middleline.valid}">
				<h3>{{ getHeadline(OrcadentQuestionnaireSection.MIDDLELINE) | translate}}</h3>
				@if (!middleline.valid) {
					<p>({{"required" | translate}})</p>
				}
			</div>
			<div class="flex-row">
				<middleline-form
					[parentForm]="questionnaireForm"
					[nestedFormGroupName]="'middleline'"
					[isUpperJaw]="true"
					data-cy="middlelineUj">
				</middleline-form>
				<middleline-form
					[parentForm]="questionnaireForm"
					[nestedFormGroupName]="'middleline'"
					[isUpperJaw]="false"
					data-cy="middlelineLj">
				</middleline-form>
			</div>
		</section>

		<!-- Frontzähne -->
		<section>
			<div class="required-header"
				 [ngClass]="{invalid: !anteriorTeeth.valid}">
				<h3>{{ getHeadline(OrcadentQuestionnaireSection.ANTERIOR_TEETH) | translate}}</h3>
				@if (!anteriorTeeth.valid) {
					<p>({{"required" | translate}})</p>
				}
			</div>
			<div class="flex-row">
				<anterior-teeth-form
					[parentForm]="questionnaireForm"
					[nestedFormGroupName]="'anteriorTeeth'"
					[isUpperJaw]="true"
					data-cy="anteriorTeethUj">
				</anterior-teeth-form>
				<anterior-teeth-form
					[parentForm]="questionnaireForm"
					[nestedFormGroupName]="'anteriorTeeth'"
					[isUpperJaw]="false"
					data-cy="anteriorTeethLj">
				</anterior-teeth-form>
			</div>
		</section>

		<!-- Seitenzähne -->
		<section>
			<div class="required-header"
				 [ngClass]="{invalid: !posteriorTeeth.valid}">
				<h3>{{ getHeadline(OrcadentQuestionnaireSection.POSTERIOR_TEETH) | translate}}</h3>
				@if (!posteriorTeeth.valid) {
					<p>({{"required" | translate}})</p>
				}
			</div>
			<div class="wrapping-grid">
				<posterior-teeth-form
					[parentForm]="questionnaireForm"
					[nestedFormGroupName]="'posteriorTeeth'"
					[quadrantFormGroupName]="Quadrant.Q1"
					data-cy="posteriorTeethQ1">
				</posterior-teeth-form>
				<posterior-teeth-form
					[parentForm]="questionnaireForm"
					[nestedFormGroupName]="'posteriorTeeth'"
					[quadrantFormGroupName]="Quadrant.Q2"
					data-cy="posteriorTeethQ2">
				</posterior-teeth-form>
				<posterior-teeth-form
					[parentForm]="questionnaireForm"
					[nestedFormGroupName]="'posteriorTeeth'"
					[quadrantFormGroupName]="Quadrant.Q3"
					data-cy="posteriorTeethQ3">
				</posterior-teeth-form>
				<posterior-teeth-form class="border-non"
					[parentForm]="questionnaireForm"
					[nestedFormGroupName]="'posteriorTeeth'"
					[quadrantFormGroupName]="Quadrant.Q4"
					data-cy="posteriorTeethQ4">
				</posterior-teeth-form>
			</div>
		</section>
		<!-- vorhandene Attachments für Bewegungsplanung entfernen -->
		<section>
			<div class="required-header"
				 [ngClass]="{invalid: !removeAttachmentsForMovement.valid}">
				<h3>{{ getHeadline(OrcadentQuestionnaireSection.REMOVE_ATTACHMENTS_FOR_MOVEMENT) | translate}}</h3>
				@if (!removeAttachmentsForMovement.valid) {
					<p>({{"required" | translate}})</p>
				}
	  		</div>
			<div class="flex-row">
				<three-options-form
					[parentForm]="questionnaireForm"
					[nestedFormGroupName]="'removeAttachmentsForMovement'"
					[isUpperJaw]="true"
					[answerRecord]="RemoveAttachmentsForMovementAnswerRecord"
					data-cy="removeAttachmentMovementUj"
					>
				</three-options-form>
				<three-options-form
					[parentForm]="questionnaireForm"
					[nestedFormGroupName]="'removeAttachmentsForMovement'"
					[isUpperJaw]="false"
					[answerRecord]="RemoveAttachmentsForMovementAnswerRecord"
					data-cy="removeAttachmentMovementLj"
					>
				</three-options-form>
			</div>
	   </section>
		<!-- Position Attachments für Bewegungsplanung -->
		<section>
			<div class="required-header"
				 [ngClass]="{invalid: !attachmentPositionMovement.valid}">
				<h3>{{ getHeadline(OrcadentQuestionnaireSection.ATTACHMENT_POSITION_MOVEMENT) | translate}}</h3>
				@if (!attachmentPositionMovement.valid) {
					<p>({{"required" | translate}})</p>
				}
	  		</div>
			<div class="flex-row">
				<attachment-position-movement-form
					[parentForm]="questionnaireForm"
					[nestedFormGroupName]="'attachmentPositionMovement'"
					[isUpperJaw]="true"
					data-cy="attachmentPositionMovementUj">
				</attachment-position-movement-form>
				<attachment-position-movement-form
					[parentForm]="questionnaireForm"
					[nestedFormGroupName]="'attachmentPositionMovement'"
					[isUpperJaw]="false"
					data-cy="attachmentPositionMovementLj">
				</attachment-position-movement-form>
			</div>
		</section>
		<!-- ASR (IPR) -->
		<section>
			<div class="required-header"
				 [ngClass]="{invalid: !ipr.valid}">
				<h3>{{ getHeadline(OrcadentQuestionnaireSection.IPR) | translate}}</h3>
				@if (!ipr.valid) {
					<p>({{"required" | translate}})</p>
				}
	  		</div>
			<div class="flex-row">
				<three-options-form
					[parentForm]="questionnaireForm"
					[nestedFormGroupName]="'ipr'"
					[isUpperJaw]="true"
					[answerRecord]="IprAnswerRecord"
					data-cy="iprUj"
					>
				</three-options-form>
				<three-options-form
					[parentForm]="questionnaireForm"
					[nestedFormGroupName]="'ipr'"
					[isUpperJaw]="false"
					[answerRecord]="IprAnswerRecord"
					data-cy="iprLj"
					>
				</three-options-form>
			</div>
		</section>

		<!-- Elastic cuts -->
		<section>
			<div>
				<h3>{{getHeadline(OrcadentQuestionnaireSection.ELASTIC_CUTS)}}</h3>
			</div>
			<div class="two-column-grid">
				<label>{{"fromTo" | translate}}</label>
				<mat-form-field>
					<input matInput formControlName="elasticCuts">
				</mat-form-field>
			</div>
		</section>

		<!-- Button Cuts -->
		<section>
			<div>
				<h3>{{getHeadline(OrcadentQuestionnaireSection.BUTTON_CUTS)}}</h3>
			</div>
			<div class="two-column-grid">
				<label>{{"at" | translate}}</label>
				<mat-form-field>
						<input matInput formControlName="buttonCuts" >
				</mat-form-field>
			</div>
		</section>

		<!-- Pontics -->
		<section>
			<div>
				<h3>{{getHeadline(OrcadentQuestionnaireSection.PONTICS)}}</h3>
			</div>
			<div class="two-column-grid" formGroupName="pontics">
				<label>{{"half at" | translate}}</label>
				<mat-form-field>
					<input matInput formControlName="half" >
				</mat-form-field>
			</div>
			<div class="two-column-grid" formGroupName="pontics">
				<label>{{"full at" | translate}}</label>
				<mat-form-field>
					<input matInput formControlName="full">
				</mat-form-field>
			</div>
		</section>

		<!-- Eruption Caps -->
		<section>
			<h3>{{getHeadline(OrcadentQuestionnaireSection.ERUPTION_CAPS)}}</h3>
			<div class="flex-column" formGroupName="eruptionCaps">
				<mat-checkbox formControlName="q1">{{ "endständiger Zahn" | translate}} Q1</mat-checkbox>
				<mat-checkbox formControlName="q2">{{ "endständiger Zahn" | translate}} Q2</mat-checkbox>
				<mat-checkbox formControlName="q3">{{ "endständiger Zahn" | translate}} Q3</mat-checkbox>
				<mat-checkbox formControlName="q4">{{ "endständiger Zahn" | translate}} Q4</mat-checkbox>
			</div>
		</section>
		<!-- individual comments  -->
		<section>
			<h3>{{ getHeadline(OrcadentQuestionnaireSection.INDIVIDUAL_COMMENTS) | translate}}</h3>
			<textarea id="individualComments" formControlName="individualComments"
				placeholder="{{'Anamnesis.ObjectivesCommentPlaceholder' | translate}}"
			></textarea>
		</section>
	</form>
	<br>
	<mat-error *ngIf="!checkValid()" data-cy="required-input-missing-hint">
		{{ "Anamnesis.RequiredInputMissingHint" | translate }}
	</mat-error>
	<br>
</section>
<ux-next-back-actions [disabledNext]="!checkValid()" (action)="onAction($event)"></ux-next-back-actions>
